import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/x/avgEngagementRateHistory';
import { bestTimeToPostConfig } from '@/lib/analytics/charts/x/bestTimeToPost';
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/x/followerGrowthHistory';
import { likesHistoryConfig } from '@/lib/analytics/charts/x/likesHistory';
import { postLifespanConfig } from '@/lib/analytics/charts/x/postLifespan';
import { postsDistributionConfig } from '@/lib/analytics/charts/x/postsDistribution';
import { postsHistoryConfig } from '@/lib/analytics/charts/x/postsHistory';
import { repostsHistoryConfig } from '@/lib/analytics/charts/x/repostsHistory';
import { avgEngagementRatePerPostConfig } from '@/lib/analytics/kpis/x/avgEngagementRatePerPost';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/x/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/x/followersEvolutionPercentage';
import { impressionsPublicConfig } from '@/lib/analytics/kpis/x/impressionsPublic';
import { postCountConfig } from '@/lib/analytics/kpis/x/postCount';
import { postEngagementsConfig } from '@/lib/analytics/kpis/x/postEngagements';
import { totalFollowersConfig } from '@/lib/analytics/kpis/x/totalFollowers';
import { totalFollowingConfig } from '@/lib/analytics/kpis/x/totalFollowing';
import { totalLikeCountConfig } from '@/lib/analytics/kpis/x/totalLikeCount';
import { totalReplyCountConfig } from '@/lib/analytics/kpis/x/totalReplyCount';
import { totalRepostCountConfig } from '@/lib/analytics/kpis/x/totalRepostCount';
import { postRankingConfig } from '@/lib/analytics/widget/x/postRanking';
import { SIZE_50 } from '@/lib/gridElements/size';

export const OverviewX = [
    // Line 1
    totalFollowersConfig,
    totalFollowingConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,

    // Line 2
    { ...impressionsPublicConfig, size: SIZE_50 },
    { ...avgEngagementRatePerPostConfig, size: SIZE_50 },

    // Line 3
    followerGrowthHistoryConfig,
    avgEngagementRateHistoryConfig,

    // Line 4
    postRankingConfig,

    // Line 5 – defaultFilter drives the initial 'type' parameter (like Instagram best time to post)
    { ...bestTimeToPostConfig, defaultFilter: 'engagements' },

    // Line 6
    postCountConfig,
    postEngagementsConfig,

    // Line 7
    totalLikeCountConfig,
    totalRepostCountConfig,
    totalReplyCountConfig,

    // Line 8
    postsHistoryConfig,
    repostsHistoryConfig,

    // Line  9
    postsDistributionConfig,

    // Line 10
    likesHistoryConfig,

    // Line 11
    postLifespanConfig
];

export const requestXParams = [
    // TwitterAccountMetrics
    [
        'followers',
        'following',
        'followers_evolution',
        'followers_evolution_percentage',
        'followers_history'
    ],
    // TwitterMedia + X API v2 metrics
    [
        'impressions',
        'impressions_organic',
        'impressions_paid',
        'average_engagement_rate_history',
        'posts',
        'post_engagements',
        'likes',
        'likes_organic',
        'likes_paid',
        'likes_history',
        'replies',
        'replies_organic',
        'replies_paid',
        'total_repost_count',
        'organic_repost_count',
        'promoted_repost_count',
        'posts_history',
        'reposts_history',
        'posts_distribution',
        'average_engagement_on_impressions_per_post',
        'best_time_to_post'
    ]
];

export const requestXOtherParameters = {
    best_time_to_post: {
        type: bestTimeToPostConfig.defaultFilter
    }
};
